export function productMeta(title, description, image, draft = false) {
  return {
    meta: [
      { vmid: "og:type", property: "og:type", content: "website" },
      {
        vmid: "og:image",
        property: "og:image",
        content: "https://www.ari.company" + image,
      },
      {
        vmid: "twitter:card",
        name: "twitter:card",
        content: "summary_large_image",
      },
      ...(draft
        ? [{ vmid: "robots", name: "robots", content: "noindex, nofollow" }]
        : []),
    ],
  };
}
